import React from 'react';
import { View, Text, ScrollView, StyleSheet } from 'react-native';
import { useAccounts } from '../hooks/useData';
import LoadingState from '../components/common/LoadingState';
import ErrorState from '../components/common/ErrorState';

const typeIcons = {
  checking: '🏦',
  savings: '💰',
  brokerage: '📈',
  retirement: '🪙',
  crypto: '🪙',
};

const Assets = () => {
  const { data: accounts, loading, error, refresh } = useAccounts();
  const totalAssets = accounts?.reduce((sum, acc) => sum + acc.balance, 0) || 0;

  if (loading) return <LoadingState message="Loading assets..." />;
  if (error) return <ErrorState message={error} onRetry={refresh} />;
  if (!accounts) return null;

  return (
    <ScrollView style={styles.container} contentContainerStyle={styles.content}>
      <Text style={styles.title}>Assets</Text>
      
      <View style={styles.summaryCard}>
        <Text style={styles.summaryLabel}>Total Assets</Text>
        <Text style={styles.summaryAmount}>${totalAssets.toLocaleString()}</Text>
      </View>
      
      <View style={styles.assetsList}>
        {accounts.map((acc) => (
          <View key={acc.name} style={styles.assetItem}>
            <View style={styles.assetIcon}>
              <Text style={styles.iconText}>{typeIcons[acc.type] || '💼'}</Text>
            </View>
            <View style={styles.assetInfo}>
              <Text style={styles.assetName}>{acc.name}</Text>
              <Text style={styles.assetDetails}>
                {acc.institution} <Text style={styles.assetType}>({acc.type.replace('_', ' ')})</Text>
              </Text>
            </View>
            <Text style={styles.assetBalance}>${acc.balance.toLocaleString()}</Text>
          </View>
        ))}
      </View>
    </ScrollView>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#F9FAFB',
  },
  content: {
    maxWidth: 768, // max-w-3xl equivalent
    width: '100%',
    alignSelf: 'center',
    paddingHorizontal: 24,
    paddingVertical: 24,
  },
  title: {
    fontSize: 24,
    fontWeight: 'bold',
    color: '#111827',
    marginBottom: 24,
  },
  summaryCard: {
    backgroundColor: '#FFFFFF',
    borderRadius: 16,
    paddingHorizontal: 24,
    paddingVertical: 24,
    marginBottom: 24,
    shadowColor: '#000',
    shadowOffset: {
      width: 0,
      height: 1,
    },
    shadowOpacity: 0.05,
    shadowRadius: 3,
    elevation: 1,
  },
  summaryLabel: {
    fontSize: 18,
    fontWeight: '500',
    color: '#374151',
    marginBottom: 8,
  },
  summaryAmount: {
    fontSize: 30,
    fontWeight: 'bold',
    color: '#059669',
  },
  assetsList: {
    gap: 16,
  },
  assetItem: {
    backgroundColor: '#FFFFFF',
    borderRadius: 16,
    paddingHorizontal: 16,
    paddingVertical: 16,
    flexDirection: 'row',
    alignItems: 'center',
    shadowColor: '#000',
    shadowOffset: {
      width: 0,
      height: 1,
    },
    shadowOpacity: 0.05,
    shadowRadius: 3,
    elevation: 1,
  },
  assetIcon: {
    marginRight: 16,
  },
  iconText: {
    fontSize: 32,
  },
  assetInfo: {
    flex: 1,
  },
  assetName: {
    fontSize: 16,
    fontWeight: '600',
    color: '#111827',
    marginBottom: 4,
  },
  assetDetails: {
    fontSize: 14,
    color: '#6B7280',
  },
  assetType: {
    fontSize: 12,
    color: '#9CA3AF',
  },
  assetBalance: {
    fontSize: 18,
    fontWeight: 'bold',
    color: '#111827',
  },
});

export default Assets; 